export const PERMISSION_USER_REGISTER = [
  'OperacaoClasse.Listar',
  'OperacaoClasse.Cadastrar',
  'OperacaoClasse.Alterar',
  'OperacaoClasse.Excluir',

  "Ocupacao.Listar",
  "Operacao.Alterar"
];